import { render, staticRenderFns } from "./about-chelyabinsk.vue?vue&type=template&id=8f8b7a24&"
import script from "./about-chelyabinsk.vue?vue&type=script&lang=js&"
export * from "./about-chelyabinsk.vue?vue&type=script&lang=js&"
import style0 from "./about-chelyabinsk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./about-chelyabinsk.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports